// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"45fc33aa","146":"2ea445d3","770":"a6a23dd0","813":"e714e5f1","823":"b313951e","924":"0c9b368f","980":"f1ee8a5f"}[chunkId] + ".chunk.js";
};